import platform from "./platform";
import {stage} from './stage';
import kinesis from './kinesis.js';
import permissions from "./permissions.ts";


const config = {
    platform,
    stage,
    kinesis,
    permissions
};

export default config;
